 <template>
  <div :class="`personalCenter ${$store.state.isMobile ? '' : 'personalCenterPc'}`">
    <div class="nameWarp" v-if="$store.state.isMobile">
      <div>{{$cookie.get('ticket_phone') || loginApp.phone || '未登录'}} </div>
    </div>
    <topBanner v-else></topBanner>
    <div class="pcToIndex" @click="toIndex" v-if="!$store.state.isMobile && !popShow">返回首页</div>
    <div class="backPc" @click="popShow = false" v-if="popShow && !$store.state.isMobile ">返回</div>
    <div :class="$store.state.isMobile ? '' : 'pcContent'">
      <div
        :class="`line ${$store.state.isMobile ? '' : 'pc'}`"
        v-for="item in lines"
        :key="item.id"
        @click="clickItem(item.id)"
        v-show="!(!$store.state.isMobile && popShow)"
      >
        {{item.name}}
      </div>
      <pop v-if="showAdd && !$store.state.isMobile">
        <slot>
          <div class="popContent">
            <div class="title">{{popShow ? '详细信息' : '个人信息'}}</div>
            <div class="baseLine"></div>
            <div class="lineContent">
              <div class="name">{{popShow == 4 ? '负责人' : '姓名'}}</div>
              <el-input v-model="addDetail.personName" :maxlength="16" placeholder="请输入姓名" :disabled="addDetail.personNameDisabled || addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent" v-if="popShow != 4">
              <div class="name">证件类型</div>
              <el-select v-model="addDetail.cardType" placeholder="请选择" :disabled="addDetail.haveOrder">
                <el-option
                  v-for="item in cardTypes"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val">
                </el-option>
              </el-select>
            </div>
            <div v-else class="lineContent">
              <div class="name">团队名称</div>
              <el-input v-model="addDetail.orgName" placeholder="请输入团队名称" :disabled="addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">{{popShow == 4 ? '身份证号' : '证件号码'}}</div>
              <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码" :disabled="popShow == 4 || addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">联系电话</div>
              <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number" oninput="if(value && value.length>11)value=value.slice(0,11)" :disabled="addDetail.phoneDisabled || addDetail.haveOrder"></el-input>
            </div>
            <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
            <div class="buttonConfirm" @click="!addDetail.haveOrder ? saveAddPerson(addDetail) : showAdd = false">{{!addDetail.haveOrder ? '保存' : '关闭'}}</div>
          </div>
        </slot>
      </pop>
      <div :class="`${$store.state.isMobile ? 'contacts' : 'pcItemCard contactsPc'}`" v-if="popShow">
      <div class="title1" v-if="personals.length">{{popShow == 2 ? '常用联系人' : '常用团队'}}</div>
        <div class="personalWarp">
          <personalCard v-for="(item, index) in personals" :key="item.id" :type="$store.state.isMobile?'':'line'">
            <div slot="left" class="leftName">
              <div class="index">{{index + 1}}</div>
            </div>
            <div slot="right" class="rightContent">
              <!-- 个人 -->
              <div v-if="popShow != 4">
                <div class="detail">
                  <span class="title em2">姓名</span>
                  <span class="name">{{item.personName}}</span>
                </div>
                <div class="detail">
                  <span class="title">手机号</span>
                  <span class="name">{{item.phone}}</span>
                </div>
              </div>
              <!-- 团队 -->
              <div v-else>
                <div class="detail">
                  <span class="title">团队名称</span>
                  <span class="name">{{item.orgName}}</span>
                </div>
                <div class="detail">
                  <span class="title">负责人&nbsp;&nbsp;&nbsp;</span>
                  <span class="name">{{item.personName}}</span>
                </div>
              </div>
              <div class="buttons">
                <div class="button" @click="del(item.id)" v-show="popShow == 2 && item.belongId">删除</div>
                <div class="button" @click="dissolutionGroup(item.id)" v-if="popShow == 4">解散</div>
                <div class="button" @click="edit(item)">编辑</div>
              </div>
            </div>
          </personalCard>
        </div>
        <div class="noData" v-if="!personals.length">暂无信息</div>
        <div class="backButton">
          <div class="back" @click="popShow = false" v-if="$store.state.isMobile">返回</div>
          <div class="buttonNormal" @click="addNew">{{popShow == 2 ? '添加联系人' : '添加团队'}}</div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.isMobile" class="loginOut" @click="loginOut">退出登录</div>
    <addCard
      v-if="showAdd && $store.state.isMobile"
      @handelShowAdd="handelShowAdd"
      @saveAddPerson="saveAddPerson"
      :cardTypes="cardTypes"
      :addDetail="addDetail"
      addType="personal"
      :editDetaiType="editDetaiType"
      :personals="[{}]"
      :isTeam="popShow == 4 ? true : false"
      @changeAddDetail="changeAddDetail"
    ></addCard>
  </div>
</template>

<script>
import topBanner from '../../components/common/topBanner'
import addCard from '@/components/ticket/addCard'
import pop from '../../components/common/pop'
import personalCard from '../../components/common/personalCard.vue'

export default {
  data() {
    return {
      lines: [{
        name: '基本信息',
        url: '',
        id: 1
      },{
        name: '常用联系人',
        url: '',
        id: 2
      },{
        name: '常用团队',
        url: '',
        id: 4
      },{
        name: '个人预约记录',
        url: '',
        id: 5
      },{
        name: '团队预约记录',
        url: '',
        id: 6
      }],
      cardTypes: [
        {name: '身份证', val: 1},
        {name: '护照（Passport）', val: 2},
        {name: '台胞证', val: 5},
        {name: '军官证', val: 6},
        {name: '外国人永居证', val: 7},
        {name: '港澳居民来往内地通行证', val: 3},
      ],
      userInfo: {},
      editDetaiType: 'add',
      showAdd: false,
      hasClick: false,
      popShow: '',
      personals: [],
      teams: [],
      addDetail: {},
      loginApp: {
        phone: ''
      }
    };
  },
  components: {topBanner, addCard, pop, personalCard},

  methods: {
    toIndex() {
      let query = this.$route.query
      this.$router.push({path: '/ticket/home', query})
    },
    loginOut() {
      this.$cookie.delete('token')
      location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`
    },
    clickItem(type) {
      this.personals = []
      this.popShow = ''
      if ((type == 2 || type == 4) && !this.userInfo.id) return this.$message('请先填写基本信息！')
      switch(type) {
        case 1:
          this.showAdd = true
          this.addDetail = this.userInfo
          if (this.$store.state.userPhone && !this.userInfo.id) {
            this.addDetail.phone = this.$store.state.userPhone
          }
          this.addDetail.phoneDisabled = true
          break;
        case 2:
        this.popShow = 2
        this.getContacts()
          break;
        case 4:
        this.popShow = 4
        this.getContacts()
          break;
        case 5:
        case 6:
        let query = this.$route.query
        query.orderType = type == 5 ? 2 : 1
        this.$router.push({path: '/ticket/ordersNew', query})
          break;
        default:
      } 
    },
    // 根据id获取未脱敏的数据
    changeAddDetail(res) {
      this.addDetail = res
      if (this.addDetail.id == this.$cookie.get('belongId')) {
        this.addDetail.phoneDisabled = true
      }
    },
    dissolutionGroup(id) {
      this.$ajax.delete(`/api/ticket/front/people/disband-team?id=${id}`).then((res) => {
        this.$message.success('解散成功')
        this.getContacts()
      })
    },

    handelShowAdd() {
      this.showAdd = false
    },

    // 删除常用
    del(id, type) {
      this.$ajax.delete(`/api/ticket/front/people/${id}`).then((res)=>{
        console.log(res, '423')
        if (res.rel) {
          this.$message.success('删除成功')
          this.getContacts()
        }
      })
    },

    // 编辑
    edit(item) {
      this.addDetail = JSON.parse(JSON.stringify(item))
      this.showAdd = true
      if (this.$store.state.isMobile) return
      this.addDetail.id ? this.getDetailInfo() : ''
    },

    getDetailInfo() {
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.addDetail.id}`).then((res) =>{
        res = res.data
        this.addDetail.cardNum = res.cardNum
        this.addDetail.phone = res.phone
        this.addDetail.haveOrder = res.haveOrder
        // 天津文保
        if (this.$route.query.museumCode == 215314 || this.$route.query.museumCode == 200090) {
          if (this.addDetail.id == this.$cookie.get('belongId')) {
            this.addDetail.phoneDisabled = true
          } else {
            this.addDetail.haveOrder = false
          }
        } else {
          if (this.addDetail.phone == this.$cookie.get('ticket_phone')) {
            this.addDetail.phoneDisabled = true
          }
        }
      })
    },

    // 新增
    addNew(type) {
      this.addDetail = {}
      this.showAdd = true
      if (this.popShow != 4) return
      // 团队预约新增自动带手机号
      if (this.$store.state.userPhone) {
        this.addDetail.phone = this.$store.state.userPhone
        this.addDetail.phoneDisabled = true
      }
      // 团队预约自动带账号
      if (this.userInfo.id) {
        this.addDetail.phone = this.userInfo.phone
        this.addDetail.cardNum = this.userInfo.cardNum
        this.addDetail.personName = this.userInfo.personName
        this.addDetail.phoneDisabled = true
        this.addDetail.personNameDisabled = true
      }
    },

    // 保存编辑或者新增的数据
    saveAddPerson(data) {
      if (this.hasClick) return
      // let emptyLength = 4
      // if (Object.keys(data).length < emptyLength) return this.$message.error('请将基础信息填写完整！') 
      if (this.popShow == 4) {//团队新增
        if (!data.cardNum || !data.orgName || !data.phone || !data.personName) return this.$message.warning('请将基础信息填写完整！')
      } else { //联系人新增
        if (!data.cardNum || !data.personName || !data.phone || !data.cardType) return this.$message.warning('请将基础信息填写完整！') 
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) return this.$message.warning('请输入正确的手机号') 
      if (data.id){
        return this.postPersonal(data)
      }
      // 个人：2，团队：4
      data.personType = this.popShow ? this.popShow : 2
      if (this.popShow == 2 && this.userInfo.id) data.belongId = this.userInfo.id
      // 常用团队增加常用字段
      if (this.popShow == 4) {
        data.cardType = 1
        data.common = true
      }
      this.postPersonal(data, 'add')
    },

    postPersonal(data, type) {
      this.hasClick = true
      if (type == 'add'){ //新增
        data.museumCode = this.$route.query.museumCode
        this.$ajax.post('/api/ticket/front/people', data).then((res) => {
          this.hasClick = false
          this.showAdd = false
          this.getContacts()
          if (this.userInfo.id) return
          this.getUserInfo()
        }).catch(() =>{
          this.hasClick = false
        })
        return
      }
      // 编辑
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.hasClick = false
        this.showAdd = false
        this.getContacts()
      }).catch(() =>{
        this.hasClick = false
      })
    },

    // 获取个人信息（type为2的信息）
    getUserInfo() {
      // 获取手机号
      if (this.$route.query.phone && this.$route.query.phone !== '') {
        this.$store.state.userPhone = this.$route.query.phone
        this.getbelonginfo()
      } else {
        this.$ajax('/api/ticket/front/people/get-phone').then((res) =>{
          this.$store.state.userPhone = res.data
          this.getbelonginfo()
        })
      }
    },
    
    getbelonginfo() {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.$route.query.museumCode}&personType=2`).then((res) => {
        let t = !res.data || !res.data.length
        if (!t) return this.getUserInfoDetail(res.data[0].id)
        //没有过常用联系人
        //
      })
    },

    // 根据id获取未脱敏的数据
    getUserInfoDetail(id) {
      this.$cookie.set('belongId', id)
      this.editDetaiType = 'edit'
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${id}`).then((res) =>{
        res = res.data
        this.addDetail = res
        this.userInfo = res
        this.addDetail.phoneDisabled = true
      })
    },

    // 获取常用联系人
    getContacts(type) {// 2个人 4团队
      if (!this.userInfo.id) return
      let url = this.popShow == 2 ? `/api/ticket/front/people/info?museumCode=${this.$route.query.museumCode}&belongId=${this.userInfo.id}&personType=${this.popShow}` : `/api/ticket/front/people/common?museumCode=${this.$route.query.museumCode}&type=2`
      this.$ajax(url).then((res) => {
        this.personals = res.data
      })
    },

    // 从微服务带来的token
    getTokenByLoginApp() {
      let fid = this.$cookie.get('fid')
      // if (!fid || (fid != this.$route.query.museumCode)) return
      this.$ajax.post(`/api/auth/jwt/login-app?fid=${this.$route.query.museumCode}`).then((res) => {
        this.$cookie.set('token', res.data.token)
        var pat = /(\d{3})\d*(\d{4})/;
        let phone = res.data.mobilePhone.replace(pat, '$1****$2');
        this.$cookie.set('ticket_phone', phone)
        this.loginApp.phone = phone
        console.log(this.loginApp, 222)
        this.getUserInfo()
      })
    },

  },

  created() {
    if (this.$cookie.get('_uid') && this.$cookie.get('fid') && this.$cookie.get('_d')) {
      return this.getTokenByLoginApp()
    }
    this.getUserInfo()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.personalCenter{
  background: #99999921;
  min-height: 100vh;
  &.personalCenterPc{
    min-width: 1200px;
  }
  .loginOut{
    padding: 0.2rem 0.3rem;
    font-size: 0.4rem;
    width: 2.5rem;
    margin: auto;
    margin-top: 1rem;
    border-radius: 0.2rem;
  }
	.nameWarp{
    height: 2rem;
    padding-top: 0.8rem;
    margin-bottom: 1rem;
    div{
      margin: 0 0.4rem;
      line-height: 2rem;
      font-size: 0.45rem;
      padding-left: 2rem;
      text-align: left;
      background-color: #fff;
      border-top-left-radius: 0.12rem;
      border-top-right-radius: 0.12rem;
      position: relative;
      &:before{
        position: absolute;
        content: '';
        display: inline-block;
        height: 1.2rem;
        width: 1.2rem;
        top: 0.4rem;
        left: 0.5rem;
      }
    }
  }
  .line{
    height: 1.4rem;
    font-size: 0.4rem;
    line-height: 1.4rem;
    background: #fff;
    margin: 0.4rem;
    padding-left: 1.6rem;
    text-align: left;
    border-radius: 0.1rem;
    position: relative;
    cursor: pointer;
    &:before{
      position: absolute;
      content: '';
      display: inline-block;
      height: 0.5rem;
      width: 0.5rem;
      top: 0.42rem;
      left: 0.7rem;
    }
    &:nth-child(1):before{
      -webkit-mask: url('~@/assets/ticket/user.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/user.svg') 0 0/100% 100% no-repeat;
    }
    &:nth-child(2):before{
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/member.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/member.svg') 0 0/100% 100% no-repeat;
    }
    &:nth-child(3):before{
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/users.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/users.svg') 0 0/100% 100% no-repeat;
    }
    &:nth-child(4):before, &:nth-child(5):before{
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/record.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/record.svg') 0 0/100% 100% no-repeat;
    }
  }
  .pcToIndex{
    right: calc(50vw - 600px);
    top: calc(100px + 0.3rem);
    position: absolute;
  }
  .contacts{
    width: 100vw;
    height: calc(100vh - 1.5rem);
    overflow-y: scroll;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background: #fff;
    padding-bottom: 2rem;
    .personalWarp{
      width: 100vw;
    }
    .backButton{
      position: fixed;
      bottom: 0rem;
      left: 0rem;
      height: 1.5rem;
      font-size: 0.4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 2.9rem 0 0.8rem;
      right: 0;
      background: #fff;
      box-shadow: 0px -3px 18px 0px #c4c4c475;
      .buttonNormal{
        margin: 0;
      }
      .back{
        line-height: .7rem;
        font-size: .4rem;
        border: 1px solid rgba(114,106,106,.8);
        padding: 0 0.3rem;
        border-radius: 0.2rem;
        color: rgba(114,106,106,.8);
        margin-right: 0.3rem;
      }
    }
    .title1{
      font-size: 0.5rem;
      margin: 0.5rem 0;
    }
    .leftName{
      writing-mode: horizontal-tb;
      height: 2.5rem;
      .index{
        padding-top: 0.9rem;
      }
    }
    .em2{
      letter-spacing: 0.5em;
    }
    .buttons{
      display: flex;
      justify-content: flex-end;
      align-content: center;
      margin-right: 0.3rem;
      cursor: pointer;
      .button{
        width: 1rem;
        line-height: 0.8rem;
        height: 0.8rem;
        font-size: 0.4rem;
        margin-right: 0.2rem;
        &:first-child{
          color: #a22424;
        }
      }
    }
  }
  .noData{
    text-align: center;
    font-size: 0.4rem;
    margin-top: 3rem;
  }
  .pc{
    &.line{
      width: 200px;
      padding-left: 0px;
      display: inline-block;
      margin: 20px 0;
      height: 250px;
      line-height: 300px;
      font-size: 24px;
      margin-right: 45px;
      text-align: center;
      margin-top: calc(50vh - 260px);
      &:nth-child(1):before{
        height: 45px;
        width: 45px;
        left: 73px;
      }
      &:nth-child(5){
        margin-right: 0
      }
      &:before{
        position: absolute;
        content: '';
        display: inline-block;
        height: 55px;
        width: 55px;
        top: 50px;
        left: 70px;
      }
    }
  }
  .popWarp .tips{
    font-size: 18px;
    line-height: 36px;
    margin-top: 15px;
    text-align: left;
    margin-left: 30px
  }
  .backPc{
    position: absolute;
    left: calc(50vw - 510px);
    top: calc(110px + 0.3rem);
    font-size: 18px;
    padding: 3px 15px;
    border: 1px solid;
    cursor: pointer;
    border-radius: 6px;
  }
  .contactsPc{
    background: rgba(0,0,0,0);
    padding-top: 0;
    .personalWarp{
      display: flex;
      flex-wrap: wrap;
      // text-align: left;
    }
    .back{
      position: fixed;
    }
    .title1{
      font-size: 30px;
      margin-bottom: 20px;
    }
    &.pcItemCard{
      margin-bottom: 0;
    }
    .personalCard{
      width: 46%;
      height: 180px;
      margin: 30px 6% 30px 0;
      // display: inline-flex;
      &:nth-child(2n){
        margin-right: 0;
      }
      .leftName{
        writing-mode: horizontal-tb;
        height: 80px;
        .index{
          padding-top: 50px;
          font-size: 25px;
          line-height: 40px;
        }
      }
      .buttons{
        display: flex;
        justify-content: flex-end;
        align-content: center;
        margin-right: 10px;
        cursor: pointer;
        margin-top: 20px;
        .button{
          width: 55px;
          line-height: 40px;
          height: 40px;
          font-size: 24px;
          margin-right: 0.2rem;
          &:first-child{
            color: #a22424;
          }
        }
      }
    }
    .backButton{
      position: absolute;
      right: calc(50vw - 510px);
      top: calc(100px + 0.3rem);
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .buttonNormal{
        margin:0;
        margin-left: 30px;
        width: 150px;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
      }
    }
    .noData{
      font-size: 0.2rem;
      margin-top: 1rem;
    }
  }
}
</style>
<style type="text/css" lang="scss">
  .contactsPc {
    .personalCard .leftLine{
      min-height: 140px !important;
      width: 50px !important;
      padding-left: 30px !important;
    }
    .personalCard .right{
      padding: 0;
    }
  }
</style>